<template>
  <div class="g_atn atn__h">
    <div class="train__info">
      <div class="train__item" uk-tooltip="Шаг">
        <div class="train__ico train__ico--1"></div>
        <small>Шаг:</small>
        {{ local_steps }}
      </div>
      <div class="train__item" uk-tooltip="Ошибок сделано">
        <div class="train__ico train__ico--2"></div>
        <small>Ошибок:</small>
        {{ errors }}
      </div>
      <div
        class="train__item"
        v-if="$route.params.isHomework"
        uk-tooltip="Выполнено"
      >
        <div class="train__ico train__ico--4"></div>
        <small>Выполнено:</small>
        <div class="train__nowrap">
          {{ $route.params.total }} из {{ $route.params.qnt }}
        </div>
      </div>
      <div class="train__item" uk-tooltip="Времени прошло">
        <div class="train__ico train__ico--3"></div>
        <span
          ><small>Времени прошло:</small> {{ timer.minutes }}:{{
            timer.seconds
          }}</span
        >
      </div>
    </div>

    <div v-if="mode === 'fight' && !preStart">
      <button
        class="uk-button uk-button-primary"
        @click="onStart"
        :id="'start-' + inkey"
      >
        СТАРТ!
      </button>
    </div>

    <div v-show="preStart && !local_finish" class="flash__game">
      <div class="showed_number" :class="'showed_number-' + inkey">
        <abacus
          :can-change="false"
          :axis-qnt="qnt"
          :show-clear="false"
          :show-sum="false"
          :show-numbers="false"
          :animate="false"
          :abacus-value="currentNumber"
        ></abacus>
      </div>
      <!--<h3>Число: {{ currentNumber }}</h3>-->
      <div v-if="is_error" class="flash__message flash__error">
        Неправильно! <span v-html="result"></span>
      </div>
      <div v-if="is_success" class="flash__message flash__success">
        Правильно! <span v-html="result"></span>
      </div>

      <p v-if="result" class="flash__result">
        <strong>Ваш результат:</strong><br />
        <span v-html="result"></span>
        <span
          class="mental__checks"
          :class="+userNumber === currentNumber ? '' : 'active'"
        ></span>
      </p>

      <div v-if="!readyNext" class="flash__answer">
        <div v-if="!result" class="columns__ok">
          <input
            type="tel"
            :id="'game_input-' + inkey"
            class="game_input uk-input"
            autocomplete="off"
            v-model="userNumber"
            @keyup.enter="nextStep2"
            :placeholder="$parent.users > 3 ? 'Ответ' : 'Введите ответ'"
          />
          <button class="uk-button uk-button-primary" @click="nextStep">
            OK
          </button>
        </div>
      </div>

      <div v-if="readyNext">
        <button
          :id="'next-' + inkey"
          class="uk-button uk-button-primary"
          @click="restart"
        >
          Дальше
        </button>
      </div>
    </div>
    <div v-if="local_finish">
      <p>Ваши результаты:</p>
      <div v-for="(result, key) in results" :key="result.id">
        <p>
          <strong>Шаг: {{ key + 1 }}: </strong>
          <span>Число: {{ result.cifers }}</span
          >, Ваш ответ: {{ result.user_answer }}
          <span
            class="mental__checks"
            :class="+result.user_answer === result.cifers ? '' : 'active'"
          ></span>
        </p>
      </div>
      <p class="scores">
        Ты зарабатываешь <strong>{{ scores }}</strong>
        {{ $root.getNoun(scores, "балл", "балла", "баллов") }}!
      </p>
      <button
        class="uk-button uk-button-primary"
        @click="fullRestart"
        v-if="!checkHomeworkFinish()"
      >
        Повторим?
      </button>
      <button class="uk-button uk-button-primary" @click="onStopTrainer" v-else>
        Закончить
      </button>
    </div>
  </div>
</template>

<script>
import abacus from "../abacus/abacus";
import { mix } from "./../mixin";
import { flashmix } from "./flash-mixin";

export default {
  name: "atn",
  mixins: [mix, flashmix],
  components: {
    abacus,
  },
  data() {
    return {};
  },

  methods: {
    nextStep2() {
      if (this.$parent.users > 1) {
        console.log("FullCheck");
        this.$root.$emit("fullCheck");
      } else {
        console.log("NS2 Next Step");
        //this.preStart = false;
        this.nextStep();
      }
    },
    nextStep() {
      console.log("next step");
      if ((this.userNumber && !this.result) || this.$parent.users > 1) {
        console.log("NextStep");
        this.checkError();
        let app = this;
        this.finish = true;
        this.readyNext = true;
        /*setTimeout(function () {
            if (app.$parent.users === 1) {
              $('#next-' + app.inkey).focus();
            }
          }, 200);*/
        this.$parent.startReaction(this.currentNumber, this.userNumber);

        let result = {
          cifers: this.currentNumber,
          user_answer: +this.userNumber,
          timer: this.timer,
        };
        this.results.push(result);
        this.local_results.push(result);

        if (this.counter === +this.params.qnt) {
          console.log("Конец игры");
          this.local_finish = true;

          this.addScores();
          if (this.local_steps > 1 && this.stat_id) {
            this.updateStats();
          } else {
            this.makeStats();
          }
        } else {
          console.log("Следующий шаг");
        }
      }
    },
    onStart() {
      this.generateNumber();
      this.startTimer();
      this.preStart = true;
    },
    restart() {
      if (this.checkFinishHomework()) {
        this.onStopTrainer();
      } else {
        if (!this.local_finish) {
          console.log("Restart");
          this.$parent.scroll();
          this.result = "";
          this.readyNext = false;
          this.preStart = true;
          this.counter++;
          this.local_steps++;
          this.startTimer();
          this.generateNumber();
          this.userNumber = "";
        } else {
          this.fullRestart();
        }
      }
    },
    generateNumber() {
      console.log("Generate Number");
      $(".showed_number-" + this.inkey).css("visibility", "visible");
      //$('.showed_number').show();
      //let from = +this.params.from;
      //let from = 1;
      let from = _.fill(new Array(+this.params.to), 0);
      let app = this;
      from[0] = 1;
      from = Number(_.join(from, ""));
      let dt =
        typeof this.params.direct_to !== "undefined"
          ? +this.params.direct_to
          : 9;
      let direct_to = +this.params.to == 1 ? dt : 9;
      let to = Number(
        _.join(_.fill(new Array(+this.params.to), direct_to), "")
      );
      //console.log('From to', from, to);
      let number = this.randomInteger(from, to);
      this.currentNumber = number;
      this.speedy();
      if (window.innerWidth >= 600) {
        setTimeout(function () {
          if (app.$parent.users === 1) {
            $("#game_input-" + app.inkey).focus();
          } else {
            $("#game_input-1").focus();
          }
        }, 150);
      }

      console.log(number);
    },
  },
  mounted() {
    if (this.mode === "fight") {
      this.preStart = false;
      if (this.params.users > 1) {
        this.local_steps = 0;
      }
      $("#start-" + this.inkey).focus();
    } else {
      this.onStart();
    }
    this.$root.$on("fullCheck", () => {
      if (!this.local_finish && !this.readyNext) {
        console.log("ss");
        this.nextStep();
      }
    });
    this.$root.$on("fullStart", this.restart);
  },
  beforeDestroy() {
    this.$root.$off("fullCheck", this.nextStep);
    this.$root.$off("fullStart", this.restart);
  },
};
</script>

<style lang="scss" scoped>
.flash__game {
  position: relative;
}
</style>